import CompletionAppIcon from './assets/CompletionAppIcon';
import CompletionAppIconBe from './assets/CompletionAppIconBe';
import DrillingAppIcon from './assets/DrillingAppIcon';
import DrillingAppIconBe from './assets/DrillingAppIconBe';
import InterventionAppIcon from './assets/InterventionAppIcon';
import NoSegmentAppIconBeIdle from './assets/NoSegmentAppIconBeIdle';
import NoSegmentAppIcon from './assets/NoSegmentAppIcon';
import CompletionAppIconPng from './assets/CompletionAppIcon.png';
import CompletionAppIconBePng from './assets/CompletionAppIconBe.png';
import DrillingAppIconPng from './assets/DrillingAppIcon.png';
import DrillingAppIconBePng from './assets/DrillingAppIconBe.png';
import InterventionAppIconPng from './assets/InterventionAppIcon.png';
import InterventionAppIconBePng from './assets/InterventionAppIconBe.png';
import NoSegmentAppIconPng from './assets/NoSegmentAppIcon.png';

import { SEGMENTS } from '~/constants/segment';

export function getIconComponentBySegment(segment, appDevType = 'ui') {
  if (!segment || !segment.length) {
    return appDevType === 'be' ? NoSegmentAppIconBeIdle : NoSegmentAppIcon;
  }
  const isUiApp = appDevType === 'ui';
  const isBeAppActiveStatus = appDevType === 'be';
  const currentSegment = segment[0];

  if (currentSegment === SEGMENTS.COMPLETION) {
    if (isUiApp) return CompletionAppIcon;
    if (isBeAppActiveStatus) return CompletionAppIconBe;
  }
  if (currentSegment === SEGMENTS.DRILLING) {
    if (isUiApp) return DrillingAppIcon;
    if (isBeAppActiveStatus) return DrillingAppIconBe;
  }
  if (currentSegment === SEGMENTS.INTERVENTION) {
    return InterventionAppIcon;
  }

  return NoSegmentAppIconBeIdle;
}

export function getAppIcon(segment, appDevType = 'ui') {
  if (!segment || !segment.length) return NoSegmentAppIconPng;
  const isUiApp = appDevType === 'ui';
  const currentSegment = segment[0];

  if (currentSegment === SEGMENTS.COMPLETION)
    return isUiApp ? CompletionAppIconPng : CompletionAppIconBePng;
  if (currentSegment === SEGMENTS.DRILLING)
    return isUiApp ? DrillingAppIconPng : DrillingAppIconBePng;
  if (currentSegment === SEGMENTS.INTERVENTION)
    return isUiApp ? InterventionAppIconPng : InterventionAppIconBePng;

  return NoSegmentAppIconPng;
}
